// extracted by mini-css-extract-plugin
export default {"modalBox":"FTHT5N1qB6hBpyJNtJdn"};